import { factory } from '~/services/cosmicFactory';

export default factory.make();
